<template>
  <div :data-testid="getTestId('admin-sites-page')">
    <SiteCrudTable :data-testid="getTestId('admin-sites-table')" />
  </div>
</template>

<script>
import { getTestId } from '@/utils/testUtils';

export default {
  name: 'SitesPage',
  components: {
    SiteCrudTable: () => import('../../components/table/SiteCrudTable.vue')
  },
  methods: {
    getTestId(testId) {
      return getTestId(testId);
    }
  }
};
</script>
